import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
var Block = /*#__PURE__*/ styled("section", {
    target: "e21o5a30"
})("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";& >:first-child h1,& >:first-child h2,& >:first-child h3,& >:first-child h4,& >:first-child h5,& >:first-child h6{margin-top:0;padding-top:0;}display:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "block";
}, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return textStyle === Ui.RichTextStyle.Alternative ? theme.color.natural0 : theme.color.secondary100;
}, ";");
export { Block };
